import { Phone, Mail, MapPin, Building2, MessageCircle, Clock } from "lucide-react";
import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Contact() {
  return (
    <LegalLayout
      title="Contactează-ne"
      subtitle="Suntem aici pentru tine. Răspundem rapid pe telefon și WhatsApp, în zilele lucrătoare."
    >
      <div className="not-prose grid md:grid-cols-2 gap-5">
        <a
          href={`tel:${COMPANY.phoneRaw}`}
          className="group p-6 rounded-2xl bg-sky-50 border border-sky-100 hover:bg-white hover:border-cyan-200 hover:shadow-lg transition-all"
        >
          <div className="w-12 h-12 rounded-xl bg-cyan-600 group-hover:bg-cyan-700 flex items-center justify-center mb-4 transition-colors">
            <Phone className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-heading font-bold text-slate-900">Sună-ne direct</h3>
          <p className="text-cyan-600 font-bold mt-1">{COMPANY.phone}</p>
          <p className="text-sm text-slate-500 mt-1">Luni–Sâmbătă · 09:00–19:00</p>
        </a>

        <a
          href={`https://wa.me/${COMPANY.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="group p-6 rounded-2xl bg-sky-50 border border-sky-100 hover:bg-white hover:border-emerald-200 hover:shadow-lg transition-all"
        >
          <div className="w-12 h-12 rounded-xl bg-[#25d366] group-hover:bg-[#1da851] flex items-center justify-center mb-4 transition-colors">
            <MessageCircle className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-heading font-bold text-slate-900">WhatsApp comenzi</h3>
          <p className="text-emerald-600 font-bold mt-1">{COMPANY.phone}</p>
          <p className="text-sm text-slate-500 mt-1">Răspundem în câteva minute</p>
        </a>

        <a
          href={`mailto:${COMPANY.email}`}
          className="group p-6 rounded-2xl bg-sky-50 border border-sky-100 hover:bg-white hover:border-cyan-200 hover:shadow-lg transition-all"
        >
          <div className="w-12 h-12 rounded-xl bg-slate-900 group-hover:bg-cyan-600 flex items-center justify-center mb-4 transition-colors">
            <Mail className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-heading font-bold text-slate-900">Email</h3>
          <p className="text-slate-700 font-bold mt-1 break-all">{COMPANY.email}</p>
          <p className="text-sm text-slate-500 mt-1">Răspundem în 24h</p>
        </a>

        <div className="p-6 rounded-2xl bg-sky-50 border border-sky-100">
          <div className="w-12 h-12 rounded-xl bg-cyan-600 flex items-center justify-center mb-4">
            <Clock className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-heading font-bold text-slate-900">Program</h3>
          <p className="text-slate-700 mt-1">Luni – Vineri: 09:00 – 19:00</p>
          <p className="text-slate-700">Sâmbătă: 10:00 – 16:00</p>
          <p className="text-slate-500 text-sm mt-1">Duminică: închis</p>
        </div>
      </div>

      <h2 className="font-heading text-2xl font-bold text-slate-900 mt-10">
        Date firmă
      </h2>
      <div className="not-prose p-6 rounded-2xl bg-white border border-sky-100 space-y-3 text-sm">
        <div className="flex items-start gap-3">
          <Building2 className="w-4 h-4 text-cyan-600 mt-0.5 shrink-0" />
          <div>
            <div className="font-semibold text-slate-900">{COMPANY.legalName}</div>
            <div className="text-slate-600">
              CUI: {COMPANY.cui} · Reg. Comerț: {COMPANY.regCom}
            </div>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <MapPin className="w-4 h-4 text-cyan-600 mt-0.5 shrink-0" />
          <div className="text-slate-700">{COMPANY.address}</div>
        </div>
      </div>
    </LegalLayout>
  );
}
